<script>
import { leave } from '../api/groups';

export default {
  components: {
    CpButton: require('../button').default,
    CpButtonLink: require('../button-link').default,
    CpDialog: require('../dialog').default,
    CpBoxContent: require('../box-content').default,
    CpBox: require('../box').default,
    CpTextInput: require('../inputs/text').default,
  },
  props: {
    handleDialog: Function,
    showDialog: Boolean,
    group: Object,
  },
  name: 'CpLeaveGroupDialog',
  data() {
    return {
      loading: false,
      leaveSuccess: false,
      leaveError: false,
      successText: 'You left the group successfully!',
      errorText: 'An error has occurred!',
    };
  },
  methods: {
    leaveGroup() {
      if (!this.authUser) {
        window.location.href = '/user/login';
      } else {
        this.loading = true;
        leave(this.group.id)
          .then(response => {
            this.group.user_status = null;
            this.loading = false;
            this.leaveSuccess = true;
            setTimeout(() => {
              this.leaveSuccess = false;
              this.handleDialog();
              window.location.href = '/feed#groups';
            }, 3000);
          })
          .catch(error => {
            this.loading = false;
            this.leaveError = true;
            console.warn(error);
          });
      }
    },
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
  },
};
</script>
<template>
  <cp-dialog>
    <cp-box>
      <cp-box-content>
        <section style="margin: 2em 2em">
          <template v-if="!leaveSuccess && !leaveError" class="share-container">
            <h2 :class="{ 'black-color': true, textCenter: true, subheadline1: !$root.isMobile, headline: $root.isMobile }">
              Are you sure to leave this group?
            </h2>
            <p :class="{ 'neutral4-color': true, textCenter: true, body: !$root.isMobile, body1: $root.isMobile }">
              If you leave, you’ll have to send a request to join again.
            </p>
            <div class="btnContainer">
              <cp-button noborder @click="handleDialog()" :disabled="loading" block>Cancel</cp-button>
              <cp-button primary @click="leaveGroup()" block :loading="loading" :disabled="loading">Leave</cp-button>
            </div>
          </template>
          <template v-else-if="leaveSuccess">
            <div class="btnContainer">
              <i class="fas fa-check check-icon"></i>
            </div>
            <p :class="{ 'black-color': true, textCenter: true, subheadline1: !$root.isMobile, headline: $root.isMobile }">{{ successText }}</p>
          </template>
          <template v-else-if="leaveError">
            <svg
              @click.prevent="handleDialog()"
              class="close-svg-icon"
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
              ></path>
            </svg>
            <div class="btnContainer">
              <i class="fas fa-times error-icon"></i>
            </div>
            <p :class="{ 'black-color': true, textCenter: true, subheadline1: !$root.isMobile, headline: $root.isMobile }">{{ errorText }}</p>
          </template>
        </section>
      </cp-box-content>
    </cp-box>
  </cp-dialog>
</template>
<style scoped>
.close-svg-icon {
  cursor: pointer;
}
.share-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
}
.check-icon {
  font-size: 3em;
  color: var(--success);
}
.error-icon {
  font-size: 3em;
  color: red;
}
.btnContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.textCenter {
  text-align: center;
}
</style>
